/* ==========================================================================
   CRYSTAAL — Upsell Chouchou Éclat
   Fichier AJOUTÉ. Ne modifie aucun script natif du thème Gloow (cart.js,
   cart-drawer.js, global.js restent intacts).

   Comportement :
   1. Clic sur "+ Ajouter à ma commande" -> POST /cart/add.js (variante
      choisie, quantité 1).
   2. Succès -> affichage furtif "Votre rituel est complet ✓" puis rafraîchit
      le panier (drawer ET page classique) en récupérant le HTML courant et
      en remplaçant les zones concernées (items, totaux, barre de livraison,
      bulle du panier). Le bloc upsell disparaît alors de lui-même car la
      condition Liquid (chouchou déjà présent) devient fausse côté serveur.
   ========================================================================== */
(function () {
  'use strict';

  // Devient vrai pendant que NOTRE PROPRE refreshCartUI() modifie le DOM,
  // pour que le listener ci-dessous (qui détecte les mises à jour natives
  // du thème : +/- quantité, suppression via la corbeille) ignore les
  // mutations que nous avons causées nous-mêmes et évite toute boucle.
  var isOwnUpdate = false;

  function getCartAddUrl() {
    if (window.crystaalUpsellRoutes && window.crystaalUpsellRoutes.cartAddUrl) {
      return window.crystaalUpsellRoutes.cartAddUrl;
    }
    return '/cart/add.js';
  }

  // La section "cart-drawer" est incluse via {% section %} dans le layout du
  // thème et son HTML initial (chargement de page complet) peut ne PAS
  // refléter l'état réel du panier pour notre bloc upsell (constaté : le
  // rendu complet de page omet le bloc, alors que l'API Section Rendering
  // Shopify — /?sections=cart-drawer — le retourne toujours correctement,
  // à cart identique). On utilise donc systématiquement cette API pour le
  // tiroir plutôt que le HTML de la page complète, qui n'est pas fiable ici.
  async function fetchCartDrawerSectionHtml() {
    var response = await fetch(window.location.pathname + '?sections=cart-drawer', {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    });
    if (!response.ok) return null;
    var json = await response.json();
    return json && json['cart-drawer'];
  }

  // Sélecteurs (par ordre de préférence) de la zone qui défile réellement
  // dans le tiroir, pour pouvoir restaurer la position de scroll après un
  // remplacement complet du HTML (voir plus bas, correctif "tiroir qui
  // saute").
  var SCROLL_CONTAINER_SELECTORS = ['cart-drawer-items', '.drawer__inner'];

  function findScrollContainer(root) {
    for (var i = 0; i < SCROLL_CONTAINER_SELECTORS.length; i++) {
      var el = root.querySelector(SCROLL_CONTAINER_SELECTORS[i]);
      if (el) return { el: el, selector: SCROLL_CONTAINER_SELECTORS[i] };
    }
    return null;
  }

  async function syncCartDrawer() {
    var drawerTarget = document.querySelector('#CartDrawer');
    if (!drawerTarget) return;

    // Correctif "le tiroir saute et revient en haut" : syncCartDrawer()
    // remplace tout le innerHTML de #CartDrawer (nécessaire pour que notre
    // bloc upsell reste à jour), ce qui réinitialise à 0 le scroll de la
    // liste d'articles. Si ce remplacement survient PENDANT que le client
    // est en train de descendre dans la liste (ex. la synchronisation
    // silencieuse au chargement de page qui se termine après coup, ou une
    // resynchronisation déclenchée par une mise à jour native du panier),
    // le tiroir semblait "sauter" et revenir en haut. On mémorise donc la
    // position de scroll avant le remplacement, puis on la réapplique
    // juste après sur le nouvel élément équivalent.
    var before = findScrollContainer(drawerTarget);
    var savedScrollTop = before ? before.el.scrollTop : 0;
    var savedSelector = before ? before.selector : null;

    var html = await fetchCartDrawerSectionHtml();
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var drawerSource = doc.querySelector('#CartDrawer');
    if (drawerSource) {
      drawerTarget.innerHTML = drawerSource.innerHTML;
      var drawerEl = document.querySelector('cart-drawer');
      if (drawerEl) {
        drawerEl.classList.remove('is-empty');
      }
      if (savedSelector && savedScrollTop > 0) {
        var after = drawerTarget.querySelector(savedSelector);
        if (after) after.scrollTop = savedScrollTop;
      }
    }
  }

  async function refreshCartUI() {
    isOwnUpdate = true;
    try {
      await syncCartDrawer();

      var response = await fetch(window.location.pathname + window.location.search, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });
      var text = await response.text();
      var doc = new DOMParser().parseFromString(text, 'text/html');

      // Classic cart page: swap the cart items + footer/checkout containers
      // (stable IDs defined directly in main-cart-items.liquid /
      // main-cart-footer.liquid) so the free shipping bar, items and
      // checkout button stay in sync. We swap the section's outer wrapper
      // (closest [id^="shopify-section-"]) so the shipping bar — rendered
      // as a sibling just above #main-cart-items — is refreshed too.
      ['main-cart-items', 'main-cart-footer'].forEach(function (innerId) {
        var targetInner = document.getElementById(innerId);
        var sourceInner = doc.getElementById(innerId);
        if (!targetInner || !sourceInner) return;

        var targetSection = targetInner.closest('[id^="shopify-section-"]');
        var sourceSection = sourceInner.closest('[id^="shopify-section-"]');

        if (targetSection && sourceSection) {
          targetSection.innerHTML = sourceSection.innerHTML;
        } else {
          targetInner.innerHTML = sourceInner.innerHTML;
        }
      });

      // Header cart icon bubble (item count)
      var bubbleTarget = document.querySelector('#cart-icon-bubble');
      var bubbleSource = doc.querySelector('#cart-icon-bubble');
      if (bubbleTarget && bubbleSource) {
        bubbleTarget.innerHTML = bubbleSource.innerHTML;
      }

      document.dispatchEvent(new CustomEvent('crystaal:upsell-cart-refreshed'));
    } catch (err) {
      // Fail silently on refresh (the item was still added to the cart);
      // a manual page reload will always reflect the correct state.
      console.error('[CRYSTAAL upsell] cart refresh failed', err);
    } finally {
      // Petit délai avant de relâcher le drapeau : les listeners sont
      // notifiés de façon asynchrone (microtask/queue), on s'assure qu'ils
      // voient encore isOwnUpdate = true pour nos propres mutations DOM.
      window.setTimeout(function () {
        isOwnUpdate = false;
      }, 50);
    }
  }

  // ------------------------------------------------------------------------
  // Détection des mises à jour NATIVES du panier (thème Gloow / Dawn)
  // ------------------------------------------------------------------------
  // ANCIENNE APPROCHE (retirée) : un MutationObserver sur #CartDrawer /
  // #main-cart-footer avec {childList:true, subtree:true}. Problème
  // constaté sur mobile : "l'image du tiroir saute/freeze chaque seconde".
  // Le thème charge simultanément DEUX librairies de lazy-load natives
  // (lozad + lazysizes/ls.rias/ls.bgset) qui restructurent le DOM des
  // <img> pendant le scroll/resize (redimensionnement de la barre
  // d'adresse mobile). Un observer aussi large sur tout le sous-arbre du
  // tiroir peut être déclenché par CE churn DOM natif, sans rapport avec
  // un vrai changement de panier, et provoquer des resync répétés qui
  // détruisent/recréent toutes les <img> — exactement le symptôme
  // rapporté. On remplace donc cette détection large par un abonnement
  // ciblé à l'évènement natif pub/sub 'cart-update' que cart.js publie
  // UNIQUEMENT lors d'un vrai changement de quantité (+/-) ou d'une
  // suppression via la corbeille (voir assets/cart.js :
  // `publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', ... })`
  // dans CartItems.updateQuantity()). Note : window.PUB_SUB_EVENTS n'est
  // pas accessible globalement (const de script classique), on utilise
  // donc directement la chaîne littérale 'cart-update'.
  function observeNativeCartUpdates() {
    if (typeof window.subscribe !== 'function') return;

    var pendingSync = null;
    function scheduleSync() {
      if (isOwnUpdate) return;
      if (pendingSync) window.clearTimeout(pendingSync);
      pendingSync = window.setTimeout(function () {
        pendingSync = null;
        if (!isOwnUpdate) refreshCartUI();
      }, 150);
    }

    window.subscribe('cart-update', function () {
      if (isOwnUpdate) return;
      scheduleSync();
    });
  }

  // Synchronise le tiroir dès le chargement de page (silencieux, tiroir
  // fermé à ce stade) : garantit que le bloc upsell est correct dès le
  // tout premier clic sur l'icône panier, sans attendre une action native
  // (+ / - / suppression) qui déclencherait le listener ci-dessus.
  function initialCartDrawerSync() {
    if (!document.getElementById('CartDrawer')) return;
    isOwnUpdate = true;
    syncCartDrawer()
      .catch(function (err) {
        console.error('[CRYSTAAL upsell] initial drawer sync failed', err);
      })
      .finally(function () {
        window.setTimeout(function () {
          isOwnUpdate = false;
        }, 50);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      observeNativeCartUpdates();
      initialCartDrawerSync();
    });
  } else {
    observeNativeCartUpdates();
    initialCartDrawerSync();
  }

  async function addChouchou(root) {
    if (!root) return;
    var select = root.querySelector('.crystaal-upsell__variant-select');
    var button = root.querySelector('.crystaal-upsell__button');
    if (!select || !button || button.disabled) return;

    var variantId = parseInt(select.value, 10);
    if (!variantId) return;

    button.disabled = true;
    button.classList.add('is-loading');

    try {
      var response = await fetch(getCartAddUrl(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      });

      if (!response.ok) {
        var errorPayload = await response.json().catch(function () {
          return {};
        });
        throw new Error(errorPayload.description || 'add to cart failed');
      }

      root.classList.add('crystaal-cart-upsell--added');

      // Small delay so the "Votre rituel est complet ✓" confirmation is
      // visible before the block disappears with the cart refresh.
      window.setTimeout(refreshCartUI, 700);
    } catch (err) {
      button.disabled = false;
      button.classList.remove('is-loading');
      console.error('[CRYSTAAL upsell] add to cart failed', err);
    }
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.crystaal-upsell__button');
    if (!button) return;
    event.preventDefault();
    addChouchou(button.closest('[data-crystaal-upsell]'));
  });

  document.addEventListener('change', function (event) {
    var select = event.target.closest('.crystaal-upsell__variant-select');
    if (!select) return;
    var root = select.closest('[data-crystaal-upsell]');
    if (!root) return;
    var option = select.options[select.selectedIndex];
    var imageUrl = option && option.getAttribute('data-variant-image');
    if (imageUrl) {
      var imageEl = root.querySelector('.crystaal-upsell__image');
      if (imageEl) imageEl.src = imageUrl;
    }
  });
})();
